import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCreditCard1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} ariaLabel="credit-card-1, card, payment" maskId="round-filled-radius-0-stroke-1.5-IconCreditCard1"><path d="M2 4.75293C2 4.33872 2.33579 4.00293 2.75 4.00293H21.2422C21.6556 4.00293 21.991 4.33739 21.9922 4.75075C21.9964 6.18525 21.9962 7.61979 21.9961 9.05303L21.9961 19.2461C21.9961 19.6604 21.6603 19.9961 21.2461 19.9961H2.75C2.33579 19.9961 2 19.6604 2 19.2461V10.5H21.9961V9H2V4.75293Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCreditCard1;
